import { Product } from "@akinon/next/types";

export const findProductIndexInStorage = (options: {product: Product; productBaseCode: string}) => {
  const { product, productBaseCode } = options;

  const baseCode = product?.base_code || productBaseCode;

  const analyticsProducts = JSON.parse(localStorage.getItem('analyticsProducts'));
  const storageProduct = analyticsProducts?.find(product => product.basecode === baseCode);

  return {
    index: Number(storageProduct?.index) || 0,
    affiliate: storageProduct?.affiliate || 'FashFed'
  };
};